import { render } from "./manage-role.vue?vue&type=template&id=3b958a78"
import script from "./manage-role.vue?vue&type=script&lang=js"
export * from "./manage-role.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__